import "./LeftHomeComponent.css";

import React, { useRef, useState } from "react";
import { ModalTermosDeUso } from "../modal/ModalTermsUso/ModelTermosDeUso";
import { ModalRef } from "../../utils/modal";
import Calculator from "../calculator/calculator";
import { useTenantStore } from "../../stores/tenant/use-tenant-store";
import { useLocation } from "react-router-dom";
import { MAPPED_ROUTES } from "../../stores/tenant/routes/routes";
import { RoutePath } from "../../stores/tenant/routes/routes.types";
import { motion } from "framer-motion";
import { FluxoType } from "../../stores/tenant/tenant.types";
import BrandLockup from "../BrandLockup/BrandLockup";
// import { navigateToLp } from "../../utils/landingPage";

interface LeftHomeProps {
  logoSrc?: string;
  title: string;
  description: string;
  imgSrc?: string;
  showCalculator?: boolean;
}

const LeftHomeComponent: React.FC<LeftHomeProps> = ({ logoSrc, title, description, imgSrc, showCalculator: show }) => {
  const modalTermosDeUsoRef = useRef<ModalRef | null>(null);

  const { assets, type, features } = useTenantStore();

  let { pathname } = useLocation();
  const [prevPathname, setPrevPathname] = useState<string>("");

  const [leftSectionContent, setLeftSectionContent] = useState<{
    image?: string;
    alt?: string;
  }>({
    image: "",
    alt: "",
  });

  if (prevPathname !== pathname) {
    setPrevPathname(pathname);

    if (type === FluxoType.CONSULTOR && pathname === "/distribuidora") {
      setLeftSectionContent({
        image: assets.home.image,
        alt: assets.home.alt,
      });
    } else if (type === FluxoType.CONSULTOR && pathname === "/") {
      setLeftSectionContent({
        image: "",
        alt: "",
      });
    } else {
      const routeName = MAPPED_ROUTES[pathname as RoutePath];
      setLeftSectionContent({
        image: assets[routeName].image,
        alt: assets[routeName].alt,
      });
    }
  }

  const showCalculator = pathname === "/" && (type === FluxoType.CONSULTOR || features.shouldShowHomeCalculator);

  return (
    <div className="left-home">
      <div className="container-logo-title-description-left-home">
        <div className="left-home-header">
          <BrandLockup logoClassName="logo-energiav-new" />
        </div>
      </div>

      <motion.div className="left-home-content" initial={{ opacity: 0.5 }} animate={{ opacity: 1 }} transition={{ duration: 0.3 }}>
        <h3 className="left-home-content-title">
          <span className="brand-highlight">{title}</span>
        </h3>
        <span className="left-home-content-description">
          {description.split("\n").map((d) => (
            <p key={d} dangerouslySetInnerHTML={{ __html: d }}></p>
          ))}
        </span>

        {leftSectionContent.image && !showCalculator && (
          <motion.div className="left-home-content-icon-container">
            <motion.img
              key={leftSectionContent.image}
              initial={{ opacity: 0.4 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.3, delay: 0.05 }}
              src={leftSectionContent.image}
              alt={leftSectionContent.alt}
              className="left-home-content-icon"
            />
          </motion.div>
        )}

        {showCalculator && (
          <div className="left-home-calculator-container">
            <Calculator />
          </div>
        )}
      </motion.div>

      <ModalTermosDeUso ref={modalTermosDeUsoRef} />

      <div className="left-home-footer">
        <p className="termo-adesao" onClick={() => modalTermosDeUsoRef.current?.open()}>
          Termos de Uso e Polticia de Privacidade
        </p>
      </div>
    </div>
  );
};

export default LeftHomeComponent;
